import { useEffect, useState } from "react";
import { FaPen, FaPlus, FaTrash } from "react-icons/fa";
import Tooltip from "../ui/ToolTip";
import { BACKEND } from "../../config/configEnvs";
import { toast } from "react-toastify";
import axios from "axios";

const DayBoxItemContainer = ({reviews, day, client, programReview, deleteReview}) => {

  const [dayEvent, setDayEvent] = useState(null);

  useEffect(() => {
    const foundEvent = reviews.find((review) => {
      if (!review.date) return false; // Validar que review.date exista
      const reviewDay = review.date.split("-")[2]?.slice(0, 2); // Validar índices
      return parseInt(reviewDay) === day;
    });
    console.log(foundEvent)
    setDayEvent(foundEvent);
  }, [reviews, day]);

  const handleUpdateReview = async (newValue, eventId) => { // Actualizar el estado de la revisión
    try {
      setDayEvent((prev) => ({
        ...prev,
        status: newValue,
      }));
      await axios.put(`${BACKEND}/api/revisionesProgramadasServicios/${eventId}`, {
        status: newValue,
      },
      { withCredentials: true }
    );
    } catch (error) {
      toast.error("Error al actualizar el evento: " + error.message);
    }
  };

  return (
    <td scope="row" className="px-0 py-0 max-w-lg border border-gray-300 truncate text-center">
      {dayEvent ? (
        <div className="flex flex-row gap-0.5 items-center justify-center">

          <select 
            name="month" 
            id="month"
            className={`text-gray-700 text-xs font-bold w-[80%] bg-white hover:cursor-pointer border-gray-200 rounded-lg focus:outline-none focus:ring-0 focus:ring-blue-600 focus:border-transparent py-[6px] ${
              dayEvent.status === "Programado" ? "text-yellow-400" : 
              dayEvent.status === "Todo Ok" ? "text-green-500" : "text-red-500"
            }`}
            value={dayEvent.status}
            onChange={(e) => handleUpdateReview(e.target.value, dayEvent.id)}
          >   
            <option value={"Programado"} className="text-yellow-400">Programado</option>
            <option value={"Todo Ok"} className="text-green-500">Todo Ok</option>
            <option value={"Errores"} className="text-red-500">Errores</option>
          </select>

          {/* <Tooltip content="Comentarios">
            <button
              //onClick={() => deleteReview(dayEvent.id)}
              className="flex justify-start gap-2 items-center p-1 rounded-md cursor-pointer bg-gray-600 text-black bg-opacity-10 hover:bg-opacity-20 hover:text-green-700 transition duration-200"
            >
              <FaPen className="text-xs"/>
            </button>
          </Tooltip> */}

          <Tooltip content="Eliminar evento">
            <button
              onClick={() => deleteReview(dayEvent.id)}
              className="flex justify-start gap-2 items-center p-1 rounded-md cursor-pointer bg-gray-600 text-black bg-opacity-10 hover:bg-opacity-20 hover:text-red-700 transition duration-200"
            >
              <FaTrash className="text-xs"/>
            </button>
          </Tooltip>

        </div>
      ) : (
        <div className="flex items-center justify-center">
          <Tooltip content="Agendar nueva revisión">
            <button
              onClick={() => {
                programReview(day, client.id)
              }}
              className="flex justify-start gap-2 items-center p-1 rounded-md cursor-pointer bg-blue-600 text-gray-300 bg-opacity-10 hover:bg-opacity-20 hover:text-blue-700 hover:border-blue-400 transition duration-200"
            >
              <FaPlus className="text-xs"/>
            </button>
          </Tooltip>
        </div>
      )}
    </td>
  )
}

export default DayBoxItemContainer